import PropTypes from "prop-types"
import React from "react"

import Form from "src/components/Form"
import Tooltip from "src/components/Tooltip"

const TaxRateDisplayInput = ({
  combinedTaxRateDisplay,
  taxes,
  label = "Tax",
}) => {
  const hasTaxBreakdown = taxes && taxes.length > 0

  const breakdownText = hasTaxBreakdown ? (
    <div className="text-left">
      {taxes.map((tax) => (
        <div key={tax.id}>
          {tax.name}: {tax.rateDisplay}
        </div>
      ))}
    </div>
  ) : null

  return (
    <div>
      <Form.Label htmlFor="tax-rate-display">{label}</Form.Label>
      <div className="flex items-center gap-2">
        <Form.TextField
          id="tax-rate-display"
          value={combinedTaxRateDisplay || ""}
          disabled={true}
          readOnly={true}
        />
        {hasTaxBreakdown && (
          <Tooltip text={breakdownText} placement="top" variant="dark">
            <i
              className="fa-kit fa-md-info -mt-1 cursor-default text-base text-gray-600"
              role="img"
            />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

TaxRateDisplayInput.propTypes = {
  combinedTaxRateDisplay: PropTypes.string,
  taxes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      rateDisplay: PropTypes.string.isRequired,
    })
  ),
  label: PropTypes.string,
}

export default TaxRateDisplayInput
